import { isFlatFeePricingType } from "./extractJobPricingDefaults";
import type { JobPricingFormValues } from "./extractJobPricingDefaults";

export function buildJobPricingPatchPayload(
  jobType: string,
  values: JobPricingFormValues,
): { type: string; scopeOfWork: { costOverride: Record<string, unknown> } } {
  const priceNum = values.price === "" ? NaN : Number(values.price);
  const unitsNum = values.units === "" ? NaN : Number(values.units);
  const isFlatFee = isFlatFeePricingType(values.by);

  const costOverride: Record<string, unknown> = {
    by: values.by,
    price: priceNum,
    value: priceNum,
    currency: values.currency || "USD",
  };

  if (!isFlatFee && Number.isFinite(unitsNum) && unitsNum > 0) {
    costOverride.units = unitsNum;
  }

  return {
    type: jobType,
    scopeOfWork: { costOverride },
  };
}
